//modals.controller.js -- this file is responsible for triggering modals for specific tasks
define('modules/profiles/modals/modals.controller',[
    "client"
], function(
    Prospector)
{
    Prospector.module("ProfileApp.Modals", function(Modals, Prospector, Backbone, Marionette, $, _){
        Modals.Controller = {
           /* showCard: function(options) {
                require(["modules/profiles/modals/views/card.comments.view"], function(FullCardView){
                    var fcv = new FullCardView(options);
                    Prospector.trigger('showModal', {view: fcv});
                });
            },
            showBoardComments: function(options) {
                require(["modules/profiles/modals/views/board.comments.view"], function(BoardCommentView){
                    var bcv = new BoardCommentView(options);
                    Prospector.trigger('showModal', {view: bcv});
                });
            },
            showCreateCard: function(options) {
                require(["modules/profiles/modals/views/create.notes.card"], function(CreateNotesView){
                    var bcv = new CreateNotesView(options);
                    Prospector.trigger('showModal', {view: bcv});
                });
            },
            //added show create article
            showCreateArticle: function(options) {
                require(["modules/profiles/modals/views/add.article.view"], function(AddArticleView){
                    var bcv = new AddArticleView(options);
                    Prospector.trigger('showModal', {view: bcv});
                });
            },
            showSaveGroupedArticles: function(options) {
                require(["modules/profiles/modals/views/save.grouped.articles"], function(SaveGroupedArticlesView){
                    var bcv = new SaveGroupedArticlesView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: true});
                });
            },
            showHideGroupedArticles: function(options) {
                require(["modules/profiles/modals/views/hide.grouped.articles"], function(HideGroupedArticlesView){
                    var bcv = new HideGroupedArticlesView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: true});
                });
            },
            //pass in editArticlesView from edit.article.view.js
            showEditArticle: function(options) {
                require(["modules/profiles/modals/views/edit.article.view"], function(EditArticleView){
                    var bcv = new EditArticleView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: false});
                });
            },
            showUpdateAccount: function(options) {
                require(["modules/profiles/modals/views/update.account.view"], function(UpdateAccountView){
                    var bcv = new UpdateAccountView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: true});
                });
            },
            showUpdateContact: function(options) {
                require(["modules/profiles/modals/views/update.contact.profile.view"], function(UpdateContactView){
                    var bcv = new UpdateContactView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: true});
                });
            },
            showUnlinkContact: function(options) {
                require(["modules/profiles/modals/views/unlink.contact.profile.view"], function(UnlinkContactView){
                    var bcv = new UnlinkContactView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: false});
                });
            },
            showDeleteContact: function(options) {
                require(["modules/profiles/modals/views/delete.contact.profile.view"], function(DeleteContactView){
                    var bcv = new DeleteContactView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: false});
                });
            },
            showUnlinkAccount: function(options) {
                require(["modules/profiles/modals/views/unlink.account.view"], function(UnlinkAccountView){
                    var bcv = new UnlinkAccountView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: false});
                });
            },
            showDeleteAccount: function(options) {
                require(["modules/profiles/modals/views/delete.account.view"], function(DeleteAccountView){
                    var bcv = new DeleteAccountView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: false});
                });
            },
            showCreateContact: function(options) {
                require(["modules/profiles/modals/views/create.contact.profile.view"], function(CreateContactView){
                    var bcv = new CreateContactView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: false});
                });
            },
            showCreateAccount: function(options) {
                require(["modules/profiles/modals/views/create.account.view"], function(CreateAccountView){
                    var bcv = new CreateAccountView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: false});
                });
            },
            showFollowingConfirm: function(options) {
                require(["modules/profiles/modals/views/following.confirm.view"], function(FollowingConfirmView){
                    var bcv = new FollowingConfirmView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: false});
                });
            },
            showFollowingLimit: function(options) {
                if(window.user.get('summary').totalFollowing == window.entitlements.get('settings').followingLimit && window.entitlements.get('settings').followingLimit != 0){
                    require(["modules/profiles/modals/views/following.limit.view"], function(FollowingConfirmView){
                        var bcv = new FollowingConfirmView(options);
                        Prospector.trigger('showModal', {view: bcv, modalLarge: false});
                    });
                }
            },
            showWebResearchConfirm: function(options) {
                require(["modules/profiles/modals/views/web.research.confirm.view"], function(WebResearchConfirmView){
                    var bcv = new WebResearchConfirmView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: false});
                });
            },
            showBoardFilter: function(options) {
                require(["modules/profiles/modals/views/board.filter"], function(boardFilterView){
                    var bcv = new boardFilterView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: false});
                });
            },
            showFavoriteRolesGroupsControl: function(options){
                require(["modules/profiles/modals/views/favorite.roles.groups.control.view"], function(boardFilterView){
                    var bcv = new boardFilterView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: true, modalFullHeight: true});
                });
            },
            showRoleMonitoringGroupsControl: function(options){
                require(["modules/profiles/modals/views/role.monitoring.groups.view"], function(boardFilterView){
                    var bcv = new boardFilterView(options);
                    Prospector.trigger('showModal', {view: bcv, modalLarge: true, modalFullHeight: true});
                });
            }*/
        }
    });
    return Prospector.ProfileApp.Modals.Controller;
});
